import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { getSrc } from 'gatsby-plugin-image';
import Layout from '@components/layout';
import SEO from '@components/seo';
import PhotoList from '@components/leadership/photo-list';
import MainHero from '../modules/hero-module/main-hero';
import ItemProfile from '../items/item-profile-card';
import ItemCTA from '@items/item-cta';
import { siteUrl } from '@config';

export const pageQuery = graphql`
  query($contentfulId: String!, $breadcrumbRegex: String!) {
    pageData: contentfulItemMember(contentful_id: { eq: $contentfulId }) {
      ...ItemMemberFragment
    }
    breadcrumbList: allContentfulSeo(filter: { pageUrl: { regex: $breadcrumbRegex } }) {
      nodes {
        pageUrl
        pageTitle
      }
    }
  }
`;

const MemberProfile = ({ location, data }) => {
  const {
    pageData: {
      name,
      slug,
      seo,
      role,
      photos,
      email,
      linkedin,
      body,
      biography,
      callout,
      pictures,
    },
    breadcrumbList
  } = data;

  const heroTitle = {
    titleSize: 'header100_small',
    textColor: 'white',
    slashColor: 'null',
    columns: 0,
    title: name,
  };

  const ctaText = {
    titleSize: 'header80',
    textColor: 'white',
    slashColor: 'null',
    title: 'TRANSFORM YOUR ORGANIZATION',
  };

  const link = {
    internalUrl: 'who-we-are/leadership/',
  };

  const linkedinLink = {
    externalUrl: linkedin,
  };

  const emailLink = {
    externalUrl: email,
    externalType: 'email',
  };

  const breadcrumbs = breadcrumbList && breadcrumbList.nodes;

  const memberSeo = {
    ...seo,
    customSchemaJson: {
      '@context': 'https://schema.org/',
      '@type': 'Person',
      name: name,
      url: siteUrl + seo.pageUrl,
      image: photos && getSrc(photos[0]).replace(/\/\//, 'https://'),
      jobTitle: role,
      worksFor: {
        '@type': 'Organization',
        name: 'STAND 8 Technology Services',
      },
    },
  };

  return (
    <Layout location={location} footer={true}>
      {seo && <SEO data={memberSeo} location={location} breadcrumbs={breadcrumbs} />}
      <MainHero
        type="dark-purple-double-slash"
        memberHero={true}
        breadcrumbLink={link}
        breadcrumb="LEADERSHIP"
        name={name}
        role={role}
        email={emailLink}
        linkedin={linkedinLink}
        backgroundColor="darkPurple"
        heroTitle={heroTitle}
      />

      <ItemProfile title={body} biography={biography} callout={callout} photos={photos} />
      <PhotoList data={pictures} />
      <ItemCTA header={ctaText} />
    </Layout>
  );
};

MemberProfile.propTypes = {
  location: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export default MemberProfile;
